function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/memoize/dist/memoize.esm.js
// module id = +UIZ
// module chunks = 0